import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { formatPriceIL, getFieldOptions } from '../plagins/data/commponentOptions';
import useCalculatePrice from '../plagins/useCalculatePrice';
import useQueries from '../../../database/useQueries';
import { format } from 'date-fns';
import SignatureForm from '../plagins/signs/SignatureForm';
import { useContext } from 'react';
import { GlobalContext } from '../../../App';
import CustomDialog from '../plagins/dialogs/customDialog';
import PaymentsManagement from './paymentsManagementCreate';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { v4 as uuidv4 } from 'uuid';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';
import { fullSelectedCustomers, fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedGraves, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';

const NAME_ENTITY = 'רכישה';

function PurchaseCreate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormPurchases.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, getEntitiesByAttr, addOrUpdateDataPurchase, 
    AllDataSignatures, AllDataCustomers, AllDataGraves } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { grave } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, permission, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת רכישה`);
  }, [location.pathname]);
  const myPermissions = [];

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);
  const [graves, setGraves] = useState([]);
  const [clients, setClients] = useState([]);
  const [paymentsList, setPaymentsList] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [contacts, setContacts] = useState([]);
  const [openTest, setOpenTest] = useState(false);
  const [tempPayments, setTempPayments] = useState([]);
  const [defaultPayments, setDefaultPayments] = useState([]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  const [loading, setLoading] = useState(true); // מצב טעינה
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  // לוגיקה לטיפול בתשלומים
  const calculatePrice = useCalculatePrice();

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      const tempPermission = permission === 0 || myPermissions.includes(permission);
      let lock = false;
      if (!tempPermission) {
        lock = field.name === 'BookkeepingApproval' ? true : false;
      }
      return {
        ...field,
        disabled: lock ? lock : field.disabled && grave !== undefined,
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (grave, newFormValues) => {
    const areaGrave = getEntityByAttr(context?.contextAreaGraves, 'unicId', grave?.areaGraveId);
    const line = getEntityByAttr(context?.contextRows, 'unicId', areaGrave?.lineId);
    const plot = getEntityByAttr(context?.contextPlots, 'unicId', line?.plotId);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);

    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;
    const blockId = block?.unicId;
    const plotId = plot?.unicId;
    const lineId = line?.unicId;
    const areaGraveId = areaGrave?.unicId;

    newFormValues = { ...newFormValues, cemeteryId, blockId, plotId, lineId, areaGraveId, graveId: grave?.graveId, purchaseStatus: 1 };

    let graves = getEntitiesByAttr(context?.contextGraves, 'areaGraveId', areaGrave?.unicId);
    let areaGraves = getEntitiesByAttr(context?.contextAreaGraves, 'gravesList', areaGrave?.gravesList);
    let rows = getEntitiesByAttr(context?.contextRows, 'plotId', plotId);
    let plots = getEntitiesByAttr(context?.contextPlots, 'blockId', blockId);
    let blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', cemeteryId);

    let customers = context?.contextCustomers?.filter((cust) => cust?.statusCustomer === 1);

    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(blocks));
    setPlots(fullSelectedPlots(plots));
    setRows(fullSelectedRows(rows, false, null));
    setAreaGraves(fullSelectedAreaGraves(areaGraves));
    setGraves(fullSelectedGraves(graves));
    setClients(fullSelectedCustomers(customers));
    setContacts(fullSelectedCustomers(context?.contextCustomers));

    setPaymentsList([]);

    return {
      newFormValues
    };
  };

  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (grave?.unicId) {
      let data = getEntityByAttr(context?.contextGraves, 'unicId', grave?.unicId) || {};
      data = { graveId: grave?.unicId, areaGraveId: data?.areaGraveId, graveNameHe: data?.graveNameHe };

      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = data[field.name] || '';
            // כיון שזהוא טופס חדש, אין תאריך וזה רק משמש לתאריך דיפולטיבי
            if (field.input === 'date') {
              fieldValue = format(new Date(), 'yyyy-MM-dd');
            }
            if (field.name === 'BookkeepingApproval') {
              fieldValue = 1;
            }
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          { id: data?.unicId }
        );

      console.log(initialFormValues);

      let res = fieldAuto(data, initialFormValues);
      initialFormValues = res?.newFormValues;

      if (initialFormValues?.price !== undefined) {
        initialFormValues = { ...initialFormValues, price: formatPriceIL(initialFormValues?.price) };
      }

      setFormValues(initialFormValues);
    }
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);

  // פונקציה לשינוי בשדות הטופס
  const handleChange = (event) => {
    if (event.target.name === 'paymentsList') {
      setOpenTest(true);
      return;
    }

    let newFormValues = { ...formValues };

    newFormValues = { ...newFormValues, [event.target.name]: event.target.value };
    if (newFormValues?.clientId && newFormValues?.buyerStatus && newFormValues?.cemeteryId && newFormValues?.blockId && newFormValues?.plotId && newFormValues?.lineId && newFormValues?.areaGraveId && newFormValues?.graveId) {
      const resPrices = calculatePrice(newFormValues);

      let totalPrice = 0;

      let tempPrices = resPrices.map((price) => {
        totalPrice += parseInt(price.value);
        return { paymentDate: '', paymentType: price.name, customPaymentType: '', paymentAmount: price.value, receiptDocuments: [], isPaymentComplete: false, locked: false, required: true };
      });

      setDefaultPayments(tempPrices);

      setTotalPrice(totalPrice);
      newFormValues = { ...newFormValues, price: formatPriceIL(totalPrice), paymentsList: tempPrices };
    }

    setFormValues(newFormValues);
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      handleOpenForm();
    }
  };

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [signatures, setSignatures] = useState([
    {
      signatureImage: null,
      signerName: 'מלכיאל בן עזרא מזכיר ח״ק',
      signerTitle: 'מלכיאל בן עזרא מזכיר ח״ק',
      permission: 1,
      status: 1,
      timestamp: null
    },
    {
      signatureImage: null,
      signerName: 'רבקה ג׳ורנו הנה״ח',
      signerTitle: 'רבקה ג׳ורנו הנה״ח',
      permission: 3,
      status: 1,
      timestamp: null
    }
  ]);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleFormSubmit = async (submittedSignatures) => {
    const unicId = uuidv4();

    let newFormValues = { ...formValues, hashPurchase: unicId, price: totalPrice, paymentsList: JSON.stringify(formValues?.paymentsList) };
    // delete newFormValues?.cemeteryId;
    // delete newFormValues?.blockId;
    // delete newFormValues?.plotId;
    // delete newFormValues?.lineId;
    // delete newFormValues?.areaGraveId;

    setLoadingData(true);

    // הכנת הנתונים לשרת
    let filteredClient = getEntityByAttr(context?.contextCustomers, 'unicId', newFormValues?.clientId);
    delete filteredClient.fullNameHe;
    filteredClient = { ...filteredClient, statusCustomer: 2, graveId: grave?.unicId };
    let filteredGrave = getEntityByAttr(context?.contextGraves, 'unicId', grave?.unicId)
    filteredGrave = { ...filteredGrave, graveStatus: 2 };
    delete filteredGrave.cemeteryId;
    delete filteredGrave.blockId;
    delete filteredGrave.plotId;
    delete filteredGrave.lineId;
    delete filteredGrave.cemeteryNameHe;
    delete filteredGrave.blockNameHe;
    delete filteredGrave.plotNameHe;
    delete filteredGrave.lineNameHe;
    delete filteredGrave.cemeteryNameEn;
    delete filteredGrave.blockNameEn;
    delete filteredGrave.plotNameEn;
    delete filteredGrave.lineNameEn;
    delete filteredGrave.areaGraveNameHe;

    if (filteredGrave.timestamp) {
      delete filteredGrave.timestamp;
    }

    // הוספת נתוני הקבר, הלקוח, והחתימות למבנה הנתונים שנשלח לשרת
    let updatedFormValues = {
      ...newFormValues,
      updateGrave: filteredGrave,
      updateCustomer: filteredClient,
      signatures: submittedSignatures.map((element) => ({
        ...element,
        hashPurchase: unicId,
        unicId: uuidv4()
      }))
    };

    // שליחת הנתונים לשרת בפנייה אחת
    let res = await addOrUpdateDataPurchase(updatedFormValues, unicId);

    if (res === 200) {
      // פעולות לאחר הצלחה
      setLoadingData(false);
      navigate(-1);
      AllDataSignatures();
      AllDataCustomers();
      AllDataGraves();
    }
  };

  const [options, setOptions] = useState({
    cemeteryId: cemeteries,
    blockId: blocks,
    plotId: plots,
    lineId: rows,
    areaGraveId: areaGraves,
    graveId: graves,
    clientId: clients,
    contactId: contacts,
    paymentsList: paymentsList,
    association: getFieldOptions('association', optionsFields),
    buyerStatus: getFieldOptions('buyerStatus', optionsFields),
    isFuneralPayments: getFieldOptions('isFuneralPayments', optionsFields),
    numOfPayments: getFieldOptions('numOfPayments', optionsFields),
    BookkeepingApproval: getFieldOptions('BookkeepingApproval', optionsFields),
    diesSpouse: getFieldOptions('diesSpouse', optionsFields),
    purchaseStatus: getFieldOptions('purchaseStatus', optionsFields)
  });

  // פונקציה לעדכון options
  const handleUpdateOptions = (fieldName, updatedOptions) => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      [fieldName]: updatedOptions // מעדכן את השדה הרלוונטי ב-options
    }));
  };

  // useEffect שמתעדכן כאשר אחד מהאטריביוטים של options משתנה
  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      cemeteryId: cemeteries,
      blockId: blocks,
      plotId: plots,
      lineId: rows,
      areaGraveId: areaGraves,
      graveId: graves,
      clientId: clients,
      contactId: contacts,
      paymentsList: paymentsList
    }));
  }, [cemeteries, blocks, plots, rows, areaGraves, graves, clients, contacts, paymentsList]);

  // useEffect נוסף לאטריביוטים שלא תלויים ישירות במשתנים אחרים
  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      association: getFieldOptions('association', optionsFields),
      buyerStatus: getFieldOptions('buyerStatus', optionsFields),
      isFuneralPayments: getFieldOptions('isFuneralPayments', optionsFields),
      numOfPayments: getFieldOptions('numOfPayments', optionsFields),
      BookkeepingApproval: getFieldOptions('BookkeepingApproval', optionsFields),
      diesSpouse: getFieldOptions('diesSpouse', optionsFields),
      purchaseStatus: getFieldOptions('purchaseStatus', optionsFields)
    }));
  }, [optionsFields]);

  const handlePaymentsChange = (payments) => {
    setTempPayments(payments);
  };

  const handleAnswerOk = (answer) => {
    if (answer) {
      let newFormValues = { ...formValues };
      let totalPrice = 0;

      tempPayments.forEach((pay) => {
        totalPrice += parseInt(pay.paymentAmount);
      });

      setDefaultPayments(tempPayments);
      setTotalPrice(totalPrice);
      newFormValues = { ...newFormValues, price: formatPriceIL(totalPrice), paymentsList: JSON.stringify(tempPayments) };
      setFormValues(newFormValues);
    }
    setOpenTest(false);
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves) {
          setLoading(false);
        }
      } else {
        fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves'], token);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) {
    return <LoadingOverlay />;
  }

  return (
    <>
      <FormTemplate title={`הוספת ${NAME_ENTITY}`} btn={`שמור`} fields={fieldsWithDynamicDisabled} columns={columns} formValues={{ ...formValues }} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} lockUpdate={false} options={options} setOptions={handleUpdateOptions} />
      <div>
        <SignatureForm open={isFormOpen} onClose={handleCloseForm} onSubmit={handleFormSubmit} signatures={signatures} setSignatures={setSignatures} />
      </div>
      <CustomDialog open={openTest} handleClose={() => setOpenTest(false)} title={'ניהול תשלומים'} onOk={true} onCancel={true} no="ביטול" yes="אישור" onAnswer={handleAnswerOk} width={{ minWidth: '400px', maxWidth: '80%' }}>
        <PaymentsManagement defaultPayments={defaultPayments} onPaymentsChange={handlePaymentsChange} />
      </CustomDialog>
      <p>
        <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>יצירת לקוח</span>
      </p>
    </>
  );
}

export default PurchaseCreate;
